export const NEW_INFO_PRESS_INFO_TEXT =
  "이 기사는 Current Press와 중복되어 이미 'Unsuitable'로 처리되었으나, Current Press에는 없는 고유한 추가 정보를 포함하고 있습니다.\n아래 'New info details'를 확인하여 Current Press에 누락된 정보를 보강하세요.";

export const NEW_INFO_PRESS_TABLE_TITLE = "Overlapped Press with New Info";
